import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9","key":"svg-0"}],["path",{"d":"M17 12a5 5 0 1 0 -5 5","key":"svg-1"}]]

/**
 * IconLoader3
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbG9hZGVyLTMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTMgMTJhOSA5IDAgMCAwIDkgOWE5IDkgMCAwIDAgOSAtOWE5IDkgMCAwIDAgLTkgLTkiIC8+CiAgPHBhdGggZD0iTTE3IDEyYTUgNSAwIDEgMCAtNSA1IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/loader-3
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLoader3 = createReactComponent('outline', 'loader-3', 'Loader3', __iconNode);

export default IconLoader3;